const instrumentsInit = {
  isFetching: false,
  data: [
    {
      value: 1,
      key: 1,
      text: 'Rubric'
    },
    {
      disabled: true,
      value: 2,
      key: 2,
      text: 'Scale'
    },
  ],
}

export function instruments(instruments=instrumentsInit, action) {
  switch(action.type) {
    default:
      return instruments
  }
}
